<script lang="ts">
	import SwapInfoSection from './SwapInfoSection.svelte';
	import LeverageInfoSection from './LeverageInfoSection.svelte';
	import AdditionalLinks from './AdditionalLinks.svelte';
	import MarginInfoSection from './MarginInfoSection.svelte';
	import ExecutionInfoSection from './ExecutionInfoSection.svelte';

	let innerWidth: any;
	let innerHeight: any;

	let sectionExpanded: boolean = true;
	$: sectionExpanded = innerWidth ? innerWidth > 640 : true;

	function toggleSectionExpanded() {
		sectionExpanded = !sectionExpanded;
	}
</script>

<svelte:window bind:innerWidth bind:innerHeight />

<div class="border-t border-t-fx-grey-600 w-full my-2" />

<div class="flex flex-col gap-2 mb-2 w-full">
	<ExecutionInfoSection />

	<div class="border-t border-t-fx-grey-600 w-full my-1" />

	<MarginInfoSection {sectionExpanded} />
	<div class="border-t border-fx-grey-600 my-px hidden sm:block" />

	<SwapInfoSection />

	<div class="border-t border-fx-grey-600 my-px hidden sm:block" />

	<LeverageInfoSection {sectionExpanded} />

	<div class="border-t border-t-fx-grey-600 w-full my-1" />

	<AdditionalLinks />

	<button
		class="text-fx-blue text-xs sm:hidden text-right flex gap-2 justify-end"
		on:click={toggleSectionExpanded}
	>
		View {sectionExpanded ? 'Less' : 'More'}
		<img
			loading="lazy"
			src={'/down-arrow.png'}
			class="h-1.5 mt-1 transition duration-300 {sectionExpanded ? 'rotate-180' : ''}"
			alt=""
		/>
	</button>
</div>
